import styled from 'styled-components'

export const MultiSelectContainer = styled.div`
  position: relative;
  .arraw-container {
    position: absolute;
    right: 15px;
    bottom: 10px;
    padding: 3px 5px;
    background-color: #f5f8fa;
    cursor: pointer;
    opacity: 0.9;
  }

  .items-container {
    position: absolute;
    top: 110px;
    z-index: 1;
    width: 100%;
  }

  .items-container-inner {
    background-color: #f5f8fa;
    max-height: 240px;
    overflow-y: auto;
    border: 1px solid #e4e6ef;
  }

  .list-item {
    display: flex;
    align-items: start;
    padding: 4px 8px;
  }
`
